export default "__VITE_ASSET__CHobFEnb__"